export enum MapboxLanguageCode {
  af = 'ck3mydmmz0cjx1cpfxuwk39sz',
  de = 'ck3myj91121m91cqpv2yp401l',
  es = 'ck3myjsj12ptq1co3y99mum8p',
  fr = 'ck3mykdxw40t01cnyqxxs1sc3',
  ja = 'ck3myl0ln416d1clt88tcxt88',
  ko = 'ck3mylles40u71cnyrwoi8gy1',
  pt = 'ck3mym4dk2pvp1co340o71w9p',
  ru = 'ck3mymq6b1xo11cp0xjcc0qmz',
  en = 'ck3myeyc521af1crt4854gna7',
  zh = 'ck3myihwo21dy1crto9pqfmy8',
}
